import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatChipEvent as MatChipEvent } from '@angular/material/chips';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { ExtentedChip } from 'src/app/extended-chiplist/extended-chiplist.component';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { FreemiumService } from '../freemium.service';
import { mandatoryFreemiumJDKeys } from '../freemiumJobDescriptionkeys';
import * as _ from 'underscore';
import { FreemiumConstants } from '../freemiumConstants';
import { FreemiumAPIService } from '../freemium-api.service';
import { GaEventsService } from 'src/app/_services/ga-events.service';


@Component({
    selector: 'app-webbtree-jd-search-filter-modal',
    templateUrl: './webbtree-jd-search-filter-modal.component.html',
    styleUrls: ['./webbtree-jd-search-filter-modal.component.scss'],
    standalone: false
})
export class WebbtreeJdSearchFilterModalComponent implements OnInit {

  private typeAheadSubject = new Subject<{ event: Event, type: string }>();
  subscriptions: Subscription[] = [];
  showJobtitleInputLoader: Boolean = false;
  jobTitleTypeAheads: any[] = [];
  jobTitleExtendedChipList: any[] = [];
  jobTitleInput: UntypedFormControl = new UntypedFormControl(null);
  locationInput: UntypedFormControl = new UntypedFormControl(null);
  locationTypeAheads: any[] = [];
  locationExtendedChipList: any[] = [];
  showregion: string = 'asia';
  recCandCount: number = 0;
  @Input() jdResponse;
  jdFilterObj: any;
  skillsInput: UntypedFormControl = new UntypedFormControl(null);
  skillsTypeahead: any[] = [];
  showLocationInputLoader: boolean = false;
  showSkillsInputLoader: boolean = false;
  skillsExtendedChipList: any[] =[];
  companyInput: UntypedFormControl = new UntypedFormControl(null);
  showCompanyInputLoader: boolean = false;
  companyTypeahead: any[] = [];
  companyExtendedChipList: any[] = [];

  showJobMantoryChip: Boolean = false;
  showJobTitleError: Boolean = false;
  showLocationMandatoryChip: Boolean = false;
  showLocationError: Boolean = false;
  showSkillsMandatoryChip: Boolean = false;
  showCompanyMandatoryChip: Boolean =false;

  maxMandatoryJobTitleFieldCount: number = 1;
  maxMandatoryLocationCount: number = 1;
  maxMandatorySkillsCount: number = 5;
  maxMandatoryCompanyCount: number = 1;


  jobTitleMandatoryCount: number = 0;
  locationMandatoryCount: number = 0;
  skillsMandatoryCount: number = 0;
  companyMandatoryCount: number =0;

  @Input() tabname;
  filterObj: any;
  @Input() type;
  recCandLoader = true;
  @Output() updateModalFilterEvent: EventEmitter<any> = new EventEmitter();



  constructor(private personSearchService:PersonSearchService, private freemiumService: FreemiumService, private modalService: NgbModal,
      private activeModal:NgbActiveModal, private freemiumApiService: FreemiumAPIService, private gaService: GaEventsService) { }

  ngOnInit() {

    const typeaheadSub = this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event, type }) => {
      this.typeAheadSearch(event, type);
    });
    this.subscriptions.push(typeaheadSub);
    if(this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
      this.jdFilterObj = this.freemiumService.fetchFilterModalData;
    }
    else {
      this.filterObj = this.freemiumService.fetchQuickSearchData;
    }

    this.populateChips(this.tabname);

  }

  // Call this function whenever the user types something
  onTypeAheadSearch(event: Event, type: string) {
    // Emit the event and type as an object through the typeAheadSubject to apply debounce
    this.typeAheadSubject.next({ event, type });
  }

  typeAheadSearch(event, type) {
    const searchValue = (event.target as HTMLInputElement).value.trim();
    if (searchValue.length < 3) return;
    switch (type) {
      case 'jobTitle': {
        this.showJobtitleInputLoader = true;
        this.freemiumApiService.getFreemiumPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.jobTitleTypeAheads = response.data;
            this.showJobtitleInputLoader = false;
          } else {
            this.showJobtitleInputLoader = false;
          }
        });
        break;
      }
      case 'location': {
        this.showLocationInputLoader = true;
        this.freemiumApiService.getFreemiumPersonSearchListing(searchValue, 'location', this.showregion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.locationTypeAheads = response.data;
            this.showLocationInputLoader = false;
          } else {
            this.showLocationInputLoader = false;
          }
        });
        break;
      }
      case 'skills': {
        this.showSkillsInputLoader = true;
        this.freemiumApiService.getFreemiumPersonSearchListing(searchValue, 'skills', this.showregion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.skillsTypeahead = response.data;
            this.showSkillsInputLoader = false;
          } else {
            this.showSkillsInputLoader = false;
          }
        });
        break;
      }
      case 'company': {
        this.showCompanyInputLoader = true;
        this.freemiumApiService.getFreemiumPersonSearchListing(searchValue, 'company', this.showregion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.companyTypeahead = response.data;
            this.showCompanyInputLoader = false;
          } else {
            this.showCompanyInputLoader = false;
          }
        });
        break;
      }
    }
  }

  addToSelectedList(item, type: string, from: any = null) {
    const inputValue = from == 'enter' ? item.target.value : from == 'submit' ? item : item.option.value.key;
    if(!inputValue) return;
    switch (type) {
      case 'jobTitle': {
        const isInputValuePresent = this.jobTitleExtendedChipList.findIndex(jt => jt.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.jobTitleExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue+".searchastext", isSuggested: false, canStar: (this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION ? true: false) , type: 'Job Title', starred: false });
        this.jobTitleInput.reset();
        // this.showJobtitleInput = false;
         this.showJobTitleError = false;
        break;
      }
      case 'location': {
        const isInputValuePresent = this.locationExtendedChipList.findIndex(lt => lt.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.locationExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: (this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION ? true: false), type: 'Location', starred: false });
        this.locationInput.reset();
       this.showLocationError = false;
        // this.showJobTitleError = false;
        break;
      }
      case 'skills': {
        const isInputValuePresent = this.skillsExtendedChipList.findIndex(lt => lt.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.skillsExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: (this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION ? true: false), type: 'Skills', starred: false });
        this.skillsInput.reset();
        // this.showJobtitleInput = false;
        // this.showJobTitleError = false;
        break;
      }
      case 'company': {
        const isInputValuePresent = this.companyExtendedChipList.findIndex(lt => lt.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.companyExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: (this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION ? true: false), type: 'Company', starred: false });
        this.companyInput.reset();
        // this.showJobtitleInput = false;
        // this.showJobTitleError = false;
        break;
      }
    }

    if(this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
      this.jdFilterObj = this.updateJobDescriptionRequest;
      this.freemiumService.setFilterModalData(this.jdFilterObj);
    } else {
      this.filterObj = this.updateFilterQuickSearch;
      this.freemiumService.setQuickSearchData(this.filterObj);
    }


    this.getpersonSearchData();


  }

  removeChip(value, type) {
   switch(type) {
    case 'jobtitle': {

        value.starred && this.jobTitleMandatoryCount--;
        this.jobTitleExtendedChipList = _.reject(this.jobTitleExtendedChipList, {name:value.name});
      break;

    }
    case 'location': {
      value.starred && this.locationMandatoryCount--;
      this.locationExtendedChipList = _.reject(this.locationExtendedChipList, {name: value.name});
      break;

    }
    case 'skills': {
      value.starred && this.skillsMandatoryCount--;
      this.skillsExtendedChipList = _.reject(this.skillsExtendedChipList, {name: value.name});
      break;

    }
    case 'company': {
      value.starred && this.companyMandatoryCount--;
      this.companyExtendedChipList = _.reject(this.companyExtendedChipList, {name: value.name});
      break;

    }
   }

   if(this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
    this.jdFilterObj = this.updateJobDescriptionRequest;
    this.freemiumService.setFilterModalData(this.jdFilterObj);
  } else {
    this.filterObj = this.updateFilterQuickSearch;
    this.freemiumService.setQuickSearchData(this.filterObj);
  }

   this.getpersonSearchData();
  }

  toggleStar(event, type) {
    this.removeErrorMessage();
    switch(type) {
      case 'jobtitle': {
        const c = this.jobTitleExtendedChipList.find(c => c.name == event.name);
        if (c) {
          c.starred = !c.starred;
        }
        if(c.starred == true) {
          this.jobTitleMandatoryCount++;
          if(this.jobTitleMandatoryCount > this.maxMandatoryJobTitleFieldCount) {
            this.showJobMantoryChip = true;
            c.starred = false;
            this.jobTitleMandatoryCount--;
          }
        } else {
          this.jobTitleMandatoryCount--;
          this.showJobMantoryChip = false;
        }

      break;
    }
    case 'location': {
      const c = this.locationExtendedChipList.find(c => c.name == event.name);
      if (c) {
        c.starred = !c.starred;
    }
    if(c.starred == true) {
      this.locationMandatoryCount++;
      if(this.locationMandatoryCount > this.maxMandatoryLocationCount) {
        this.showLocationMandatoryChip = true;
        c.starred = false;
        this.locationMandatoryCount--;
      }
    } else {
      this.locationMandatoryCount--;
      this.showLocationMandatoryChip = false;

    }
    break;
  }
  case 'skills': {
    const c = this.skillsExtendedChipList.find(c => c.name == event.name);
    if (c) {
      c.starred = !c.starred;
  }
  if(c.starred == true) {
    this.skillsMandatoryCount++;
    if(this.skillsMandatoryCount > this.maxMandatorySkillsCount) {
      this.showSkillsMandatoryChip = true;
      c.starred = false;
      this.skillsMandatoryCount--;
    }
  } else {
    this.skillsMandatoryCount--;
    this.showSkillsMandatoryChip = false;

  }
  break;
}
  case 'company': {
    const c = this.companyExtendedChipList.find(c => c.name == event.name);
    if (c) {
      c.starred = !c.starred;
  }
  if(c.starred == true) {
    this.companyMandatoryCount++;
    if(this.companyMandatoryCount > this.maxMandatoryCompanyCount) {
      this.showCompanyMandatoryChip = true;
      c.starred = false;
      this.companyMandatoryCount--;
    }
  } else {
    this.companyMandatoryCount--;
    this.showCompanyMandatoryChip = false;

  }
  break;
}
  }
  if(this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
    this.jdFilterObj = this.updateJobDescriptionRequest;
    this.freemiumService.setFilterModalData(this.jdFilterObj);
  } else {
    this.updateFilterQuickSearch;
    this.filterObj = this.freemiumService.setQuickSearchData(this.filterObj);
  }
  if(!this.showSkillsMandatoryChip && !this.showCompanyMandatoryChip && !this.showJobMantoryChip && !this.showLocationMandatoryChip)
  this.getpersonSearchData();

}

removeTypeahead(type: any){
  const maxLength = 3
  switch (type) {
    case 'jobtitle': {
      if (!(this.jobTitleInput && this.jobTitleInput.value && this.jobTitleInput.value.length >= maxLength)) {
        this.jobTitleTypeAheads = []
      }
      break;
    }
    case 'location': {
      if (!(this.locationInput && this.locationInput.value && this.locationInput.value.length >= maxLength)) {
        this.locationTypeAheads = []
      }
      break;
    }
    case 'skills': {
      if (!(this.skillsInput && this.skillsInput.value && this.skillsInput.value.length >= maxLength)) {
        this.skillsTypeahead = []
      }
      break;
    }
    case 'company': {
      if (!(this.companyInput && this.companyInput.value && this.companyInput.value.length >= maxLength)) {
        this.companyTypeahead = []
      }
      break;
    }
  }
}

selectRegion(region) {
  this.showregion = region;
  this.locationExtendedChipList =[];
  if(this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
    this.jdFilterObj = this.updateJobDescriptionRequest;
    this.freemiumService.setFilterModalData(this.jdFilterObj);
  } else {
    this.filterObj = this.updateFilterQuickSearch;
    this.freemiumService.setQuickSearchData(this.filterObj);
  }


  this.getpersonSearchData();
}

  getpersonSearchData() {
    this.recCandLoader = true;
    const filterData = this.freemiumService.fetchQuickSearchData;
    const request = this.freemiumService.getRequestWithFilters();
    if(this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
      request.job_description_keys = this.freemiumService.getFreemiumJdKeys(this.jdFilterObj);
      filterData.job_description_keys = request.job_description_keys;

    }
    filterData.continentstobeincluded = [this.showregion];

    this.freemiumService.setQuickSearchData(filterData);
    request.continentstobeincluded = Array.isArray(this.showregion) ? this.showregion: [this.showregion];
    this.freemiumApiService.getFreemiumRecommendData(request).subscribe((res:any)=>{
      if(res.status == 'success') {
        this.recCandLoader = false;
        this.recCandCount = res.data.totalresultscount;
      }
    })
  }

  populateChips(tab) {
    if(tab == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
      this.jdFilterObj.jobtitle && this.jdFilterObj.jobtitle.forEach(j => {
        this.jobTitleExtendedChipList.push({ name: j.key.replace(/\.searchastext/g, ''), value: j.key, starred: j.isMandatory, type: 'Job Title', canStar: true, key: j.key });
      });
      this.jdFilterObj.location.length && this.jdFilterObj.location.forEach(lt => {
        this.locationExtendedChipList.push({ name: lt.key.replace(/\.searchastext/g, ''), value: lt.key, starred: lt.isMandatory, type: 'Location', canStar: true, key: lt.key });
      });
      this.jdFilterObj.skills.length && this.jdFilterObj.skills.forEach(st => {
        this.skillsExtendedChipList.push({ name: st.key.replace(/\.searchastext/g, ''), value: st.key, starred: st.isMandatory, type: 'Skills', canStar: true, key: st.key });
      });
      this.jdFilterObj.company.length && this.jdFilterObj.company.forEach(c => {
        this.companyExtendedChipList.push({ name: c.key.replace(/\.searchastext/g, ''), value: c.key, starred: c.isMandatory, type: 'Company', canStar: true, key: c.key });
      });
      this.showregion = this.jdFilterObj.locationcontinent ? this.jdFilterObj.locationcontinent.toLowerCase(): this.showregion;
    } else {
      if(this.filterObj.jobTitleSelectedList.length > 0) {
        this.filterObj.jobTitleSelectedList.forEach(j => {
          this.jobTitleExtendedChipList.push({name: j.chipkey, value: j.key, starred:false,type: 'Job Title', canStar: false, key: j.key})
        })
      }
      if(this.filterObj.skillsSelectedList.length > 0) {
        this.filterObj.skillsSelectedList.forEach(j => {
          this.skillsExtendedChipList.push({name: j.chipkey, value: j.key, starred:false,type: 'Skill', canStar: false, key: j.key})
        })
      }
      if(this.filterObj.locationSelectedList.length > 0) {
        this.filterObj.locationSelectedList.forEach(j => {
          this.locationExtendedChipList.push({name: j.chipkey, value: j.key, starred:false,type: 'Location', canStar: false, key: j.key})
        })
      }

      if(this.filterObj.companySelectedList?.length > 0) {
        this.filterObj.companySelectedList.forEach(j => {
          this.companyExtendedChipList.push({name: j.chipkey, value: j.key, starred:false,type: 'Company', canStar: false, key: j.key})
        })
      }
      this.showregion = this.filterObj.continentstobeincluded.toString();

    }

    this.getpersonSearchData();
  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  private get updateJobDescriptionRequest() {
    this.jdFilterObj.jobtitle = this.jobTitleExtendedChipList.map(jt => ({ key: jt.value ? jt.value : jt.name, isMandatory: jt.starred, suggestedKey: jt.key }));
    this.jdFilterObj.skills = this.skillsExtendedChipList.map(skill => ({ key: skill.value ? skill.value : skill.name, isMandatory: skill.starred, isSuggested: skill.isSuggested, suggestedKey: skill.key }));
    this.jdFilterObj.location = this.locationExtendedChipList.map(location => ({ key: location.value ? location.value : location.name, isMandatory: location.starred, isSuggested: location.isSuggested, suggestedKey: location.key }));
    this.jdFilterObj.company = this.companyExtendedChipList.map(cn => ({ key: cn.value ? cn.value : cn.name, isMandatory: cn.starred, isSuggested: cn.isSuggested, suggestedKey: cn.key }));
    this.jdFilterObj.locationcontinent = this.showregion;
    this.freemiumService.setFilterModalData(this.jdFilterObj);

    return this.jdFilterObj;
  }

  private get updateFilterQuickSearch() {
    this.filterObj.jobTitleSelectedList = this.jobTitleExtendedChipList.map(jt=>({key: jt.value ? jt.value : jt.name, chipkey: jt.name}))
    this.filterObj.skillsSelectedList = this.skillsExtendedChipList.map(st=>({key: st.value ? st.value : st.name, chipkey: st.name}))
    this.filterObj.locationSelectedList = this.locationExtendedChipList.map(lt=>({key: lt.value ? lt.value : lt.name, chipkey: lt.name}))
    this.filterObj.companySelectedList = this.companyExtendedChipList.map(ct=>({key: ct.value ? ct.value : ct.name, chipkey: ct.name}))

    this.filterObj.continentstobeincluded = this.showregion;

    return this.filterObj;
  }

  redirectToListing(type?) {
    if(type == 'close') {
      this.modalService.dismissAll();
    } else {
      if(this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
        this.showJobTitleError = this.jobTitleExtendedChipList.length === 0;
        this.showLocationError = this.locationExtendedChipList.length === 0;
         /**
         * GA tracking for JD Filter Submit
         */
          this.gaService.trackButtonClick('JD_Search_Filter_Submit');
      } else if(this.tabname == FreemiumConstants.REDIRECT_SOURCES.QUICK_SEARCH) {
          /**
         * GA tracking for Quick Search filter Submit
         */
           this.gaService.trackButtonClick('Quick_Search_Filter_Submit');
      }
      if(!this.showJobTitleError && !this.showLocationError)
      this.activeModal.close();
    }

  }

  removeErrorMessage() {
    this.showJobMantoryChip = false;
    this.showLocationMandatoryChip = false;
    this.showCompanyMandatoryChip = false;
    this.showSkillsMandatoryChip = false;
  }

  startFreeTrial(eventName: string) {

    this.updateModalFilterEvent.emit({type: "scroll", eventName: eventName});
  }
}
